import { ga, avocet } from 'js/analytics/adapters'

export const trackEnterBasicInformation = ({ age, weight, height }) => {
  const props = {
    Age: age,
    Weight: weight,
    Height: height,
  }
  ga.track('Enter Basic Information', props)
  avocet.track('Enter Basic Information')
}
